<template>
  <div class="content-box">
    <div class="content-header">
      <el-select
        clearable
        v-model="queryForm.storeType"
        class="input"
        :filterable="false"
        placeholder="门店类型"
      >
        <el-option
          v-for="item in queryForm.storeTypeList"
          :key="item.val"
          :label="item.name"
          :value="item.val"
        >
        </el-option>
      </el-select>
      <el-input class="input" v-model="queryForm.storeName" placeholder="输入门店名称" clearable></el-input>
      <el-input class="input" v-model="queryForm.storeShowName" placeholder="输入门店外显名称" clearable></el-input>
      <el-button @click="searchData" type="primary">搜索</el-button>
      <el-button @click="handleCreate" type="button">+ 初始化门店产品</el-button>
    </div>
    <div class="table-list">
      <ETable :columns="columns" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle"
        :cell-style="cellStyle" border>
            <template #storeName="{ row }">
                <router-link :to="'/storeList?storeName=' + row.storeName" class="a-span">{{ row.storeName }}</router-link>
            </template>

            <template #storeType="{ row }">
                <div>{{ row.storeType }}</div>
                <div>{{ row.merchantName }}</div>
            </template>
            <template #action="{row}">
              <el-button type="text" @click="productManage(row)">产品管理</el-button>
              <el-button type="text" @click="productSetting(row)">产品推荐配置</el-button>
            </template>
      </ETable>
      <el-pagination style="margin-top: 20px" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="itemTotal"></el-pagination>
    </div>
    <el-dialog title="初始化门店产品" :visible.sync="dialogVisible" width="460px" :before-close="dialogClose">
        <div class="edit-box">
            <el-form label-position="left" label-width="100px" :model="formData" ref="validateForm"
                :rules="rules">
                <el-form-item label="产品模板：" prop="productTemplate">
                  <el-radio-group v-model="formData.productTemplate">
                    <el-radio :label="0">望舌知康通用产品</el-radio>
                    <el-radio :label="1">空产品</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="症状类型：" v-if="formData.productTemplate == 0">
                  <span>取体质症状</span>
                </el-form-item>
                <!-- <el-form-item label="产品模板：">
                  <span>望舌知康通用产品</span>
                </el-form-item> -->
                <el-form-item label="门店名称:" prop="storeId">
                    <el-select
                        clearable
                        style="width: 100%"
                        v-model="formData.storeId"
                        class="dialogInput"
                        remote
                        :remote-method="getAllStoreList"
                        @focus="getAllStoreList"
                        @change="storeChange"
                        filterable
                        placeholder="请选择关联门店"
                        :loading="storeSelectLoading"
                    >
                      <el-option
                          v-for="item in allStoreList"
                          :key="item.id"
                          :label="item.storeName"
                          :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="门店外显名称:" prop="storeShowName">
                    <el-input v-model="formData.storeShowName" disabled="disabled"
                        class="dialogInput" placeholder="门店外显名称" maxlength="35">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogClose">取消</el-button>
                <el-button type="primary" @click="dialogConfirm">提交</el-button>
            </div>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import { Mixins, Component } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import loading from "@/mixins/loading";
import { getWsProductList, initWsProductList, initWsBlankProductList } from "@/api/wsProduct"
import { getNavList as getNavListApi } from "@/api/mini";
import deepCopy from "@/utils/deepCopy";
import { getAllStore } from "@/api/common";

const initFormData = {
  storeShowName: null,
  storeId: null
};

@Component({
  components: { ETable }
})
export default class WsProduct extends Mixins(loading, tablePagination) {
  dialogVisible = false;

  formData = {
    productTemplate: 0,
    storeShowName: null,
    storeId: null
  };

  allStoreList = [];
  storeSelectLoading = false;

  rules = {
    storeId: [
      { required: true, message: '请选择门店', trigger: 'blur' },
    ],
    productTemplate: [
      { required: true, message: '请选择产品模板', trigger: 'blur' },
    ],
  };

  queryForm = {
    storeType: null, // 门店类型的搜索条件
    storeTypeList: [], // 门店类型枚举列表
    storeName: "",
    storeShowName: "",
  };
  itemTotal = 0;
  tableData = [];

  columns = [
    { label: "门店ID", prop: "storeId" },
    { label: "门店类型", prop: "storeType", minWidth: "140px" },
    { label: "门店名称", prop: "storeName", minWidth: "140px" },
    { label: "门店外显名称", prop: "storeShowName", minWidth: "140px" },
    { label: "产品基准门店", prop: "", formatter: (row) => { return row.wsUseBaseStore ? "是" : "否" } },
    { label: "症状类型", prop: "", formatter: (row) => { return row.symptomType == 1 ? "取舌诊症状" : "取体质症状" }  },
    { label: "操作", prop: "action", minWidth: "100" },
  ]

  mounted() {
    this.getStoreTypeList();
    this.getAllStoreList(null);
    this.getData();
  }

  getAllStoreList(str) {
    if (typeof str == "object") {
      str = "";
    }
    getAllStore({
      storeName: str,
    })
      .then((res) => {
        res.data?.forEach(el => el.id = el.storeId)
        this.allStoreList = res.data;
      })
      .catch((err) => {});
  }

  storeChange($event) {
    const store = this.allStoreList?.find(el => el.storeId == $event);
    this.formData.storeShowName = store?.storeShowName ? store?.storeShowName : store?.storeName;
  }

  searchData() {
    this.resetCurrent();
    this.getData();
  }

  handleCreate() {
    this.dialogVisible = true;
  }

  productManage(row) {
    this.$router.push({
      path: "/wsProductManager",
      query: { storeId: row.storeId, storeName: encodeURIComponent(row.storeName) }
    })
  }

  productSetting(row) {
    this.$router.push({
      path: "/wsProductSetting",
      query: { storeId: row.storeId, storeName: encodeURIComponent(row.storeName) }
    })
  }

  dialogClose() {
      // this.formData = deepCopy(initFormData);
      this.$refs['validateForm'].resetFields();
      this.dialogVisible = false;
  }
  
  dialogConfirm() {
      this.$refs['validateForm'].validate((valid) => {
          if (valid) {
            this.$confirm("是否确定为该门店初始化望舌知康产品？", "提示", {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then((result) => {
              if (result) {
                this.showLoading();
                const params = { storeId: this.formData.storeId }
                console.log("保存参数", params);
                const api = this.formData.productTemplate == 0 ? initWsProductList : initWsBlankProductList
                api(params).then(res => {
                  this.dialogClose();
                  this.currentPage = 1;
                  this.getData();
                }).finally(() => {
                    this.hideLoading();
                });
              }
            }).catch((err) => {
                console.log("cancel del")
            });
          } else {
              console.log('error submit!!');
              return false;
          }
      })
  }

  getData() {
    const params = {
      ...this.queryForm,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
    }
    this.showLoading();
    getWsProductList(params).then((res) => {
      this.tableData = res.data.list;
      this.itemTotal = res.data.total;
    })
  }

    // 查询门店类型字典
  getStoreTypeList() {
    getNavListApi("store_type").then((res) => {
      let dists = res.data || [];
      let types = [];
      dists.forEach((item) => {
        types.push({ name: item.dictValue, val: item.id });
      });
      this.queryForm.storeTypeList = types;
      this.getData();
    });
  }
}

</script>
<style lang="scss" scoped>
@import "@/styles/app";

.content-box {
  background: #edf0f9;
}

.content-header {
  background: #ffffff;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 20px;
}

.table-list {
  margin-top: 20px;
  background: #ffffff;
  border-radius: 8px;
  padding: 40px;
}

.input {
  width: 240px;
  margin-right: 12px;
  margin-bottom: 10px;
}

.button-on {
  font-size: 14px;
  font-weight: 400;
}

.status-off {
  font-size: 14px;
  font-weight: 400;
  color: #ff6700;
}
</style>